import {
  LOADING,
  DELIVERY_LOGIN,
  DELIVERY_PROFILE,
  ASSIGNED_ORDER_LIST,
  ATTENDANCE_STATUS,
} from "../common/constant";

const initialState = {
  loading: false,
  delivery_login: {},
  delivery_profile: {},
  assigned_order_list: {},
  attendance_status: null,
};

const allapireducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADING:
      return { ...state, loading: action.payload };
    case DELIVERY_LOGIN:
      return { ...state, delivery_login: action.payload };
    case DELIVERY_PROFILE:
      return { ...state, delivery_profile: action.payload };
    case ASSIGNED_ORDER_LIST:
      return { ...state, assigned_order_list: action.payload };
    case ATTENDANCE_STATUS:
      return { ...state, attendance_status: action.payload };
    default:
      return state;
  }
};

export default allapireducer;